import { useSeitenStile } from '../components/stile';

export function KeinZugriffSeite() {
  const s = useSeitenStile();
  return (
    <section className={s.kopf}>
      <h1 className="ksb-h1">Kein Zugriff</h1>
      <p style={{ margin: 0 }}>Für diesen Bereich fehlt Ihnen die Berechtigung.</p>
    </section>
  );
}
